export default "__VITE_ASSET__fj9JCqOp__"